import React from "react";
//import ReactDOM from "react-dom";

import { HashRouter, Route, Switch } from "react-router-dom";

import indexRoutes from "./routes/index.jsx";

import getCookie from "./components/Cookie/Cookie.jsx";
import Login from "./views/Login/Login.jsx";

import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/animate.min.css";
import "./assets/sass/light-bootstrap-dashboard.css?v=1.2.0";
import "./assets/css/demo.css";
import "./assets/css/pe-icon-7-stroke.css";
import "./assets/css/pluz.css?v=0.0.1";

// Carousel
import "./assets/css/slick.min.css";
import "./assets/css/slick-theme.min.css";

import ApolloClient from "apollo-boost";
import { ApolloProvider } from "react-apollo";
import { render } from "react-dom";
import gql from "graphql-tag";

// Google Tag Manager
import TagManager from 'react-gtm-module'
// End > Google Tag Manager

const account_client = new ApolloClient({
  uri: "/api/v1/account/"
});

const analytics_client = new ApolloClient({
  uri: "/api/v1/analytics/"
});


const ANALYTICS_INSERT_PAGE = gql`
  mutation createPage($user_id: Int!, $url: String!) {
    createPage(input:{user_id:$user_id, url:$url}){
      id
    }
  }
`;



function go_to_login() {
  
  var redirect = window.location.hash.replace("#", "");

  account_client.query({
    variables:{redirect: redirect},
      query: gql`query getUrlLogin($redirect: String!){
        account_auth(redirect: $redirect){
            login_url
        }
      }`
  })
  .then(
    result => {
      window.location.replace(result.data.account_auth.login_url);
      if(result.data.account_auth.login_url == "/#/login") {
        window.location.reload();
      }
    }
  );
}


const auth_uri = "#/auth/";
if(window.location.hash.indexOf(auth_uri) === 0){// Verifica se está na página de auth
  var url_token = window.location.hash.replace(auth_uri, "");
  var url_token_split = url_token.split('?r=');
  const token_user = url_token_split[0];
  if(url_token_split[1]){
    var url_redirect = "/#"+url_token_split[1];
  } else {
    var url_redirect = window.location.protocol+"//"+window.location.host
  }
  document.cookie = "token_user="+token_user;// Grava o coookie
  window.location.replace(url_redirect);
}
  
const token_user = getCookie("token_user");


if(window.location.hash.indexOf("#/login") === 0 || window.location.hash.indexOf("#/register") === 0){// Verifica se está na página de auth
  const App = () => (
        <ApolloProvider client={account_client}>
          <HashRouter>
            <Switch>
              {indexRoutes.map((prop, key) => {
                return <Route to={prop.path} component={prop.component} key={key} />;
              })}
            </Switch>
          </HashRouter>
        </ApolloProvider>
  );
  render(<App />, document.getElementById("root"));
}
else if(token_user) {

  account_client.query({
      variables:{token:token_user},
      query: gql`
      query getUser($token: String!){
        get_user_by_token(token: $token){
            id
            name
            profileString
            susepString
            sucursalString
            numberString
        }
    }`
  })
  .then(
    result => {

      // Google Tag Manager

      var customData = {
        userId: result.data.get_user_by_token.id,
        userProject: 'Pluz',
        user: {
          id: result.data.get_user_by_token.id,
          susep: result.data.get_user_by_token.susepString,
          numero: result.data.get_user_by_token.numberString, // cpf criptografado em sha256
          perfil: result.data.get_user_by_token.profileString, 
          logado: 'true', 
          sucursal: result.data.get_user_by_token.sucursalString,
          //cursos: '' //  array de cursos inscrito e o status
        },
        page: {
          name: window.location.href,
        },
        site: {
          portal: 'Pluz'
        }
      }
      
      const tagManagerArgs = {
        gtmId: 'GTM-M2BDJQP',
        dataLayer: customData,
        customData: customData
      }
      TagManager.initialize(tagManagerArgs);
      // End > Google Tag Manager

      // Analytics
      analytics_client.mutate({
          variables:{user_id:result.data.get_user_by_token.id, url:window.location.href },
          mutation: ANALYTICS_INSERT_PAGE
      });

      var datetime = new Date();
      var timestamp = datetime.getTime();
      window.onhashchange = function() { 
        var date_now = new Date();
        var timestamp_now = date_now.getTime();
        if(timestamp_now > (timestamp+1000)) {
          analytics_client.mutate({
              variables:{user_id:result.data.get_user_by_token.id, url:window.location.href },
              mutation: ANALYTICS_INSERT_PAGE
          });
        }
      }
      // End Analytics

      if(result.data.get_user_by_token) {
        const App = () => (
          <ApolloProvider client={account_client}>
            <HashRouter>
              <Switch>
                {indexRoutes.map((prop, key) => {
                  return <Route to={prop.path} component={prop.component} key={key} />;
                })}
              </Switch>
            </HashRouter>
          </ApolloProvider>
        );
        
        render(<App />, document.getElementById("root"));
      } else {
        go_to_login();
      }
    }
  );
} else {
  go_to_login();
}





// WEBPACK FOOTER //
// ./src/index.js